<div class="bmc-user-group-detail" *ngIf="menuOptions && ((viewStatus$ | async) === 1 || (viewStatus$ | async) === 2) && (currentUserGroup && !isLoading)">
  <div class="bmc-user-group-detail__section bz-space--stack-m">
    <h4>
      <ng-container *ngIf="(viewStatus$ | async) === 2">
          {{'USER_GROUPS_DETAIL.TITLE_NEW' | translate}}
      </ng-container>
      <ng-container *ngIf="(viewStatus$ | async) === 1">
          {{'USER_GROUPS_DETAIL.TITLE_EDIT' | translate}}
      </ng-container>
    </h4>
  </div>
  <div  class="bmc-user-group-detail__container">

    <div class="bmc-user-group-detail__basic-data-container bz-space--stack-l">
      <bzg-input class="bmc-user-group-detail__basic-data-item bz-space--inline-m" [readonly]="!menuOptions[userGroupMenuOptions[userGroupMenuOptions.EditUserGroup]]" [ngModel]="currentUserGroup.name" (ngModelChange)="updateCurrentUserGroup('name', $event)">
        {{'USER_GROUPS_DETAIL.NAME' | translate}}</bzg-input>
      <bzg-input class="bmc-user-group-detail__basic-data-item bz-space--stack-l" [ngModel]="currentUserGroup.displayName" (ngModelChange)="updateCurrentUserGroup('displayName', $event)" [readonly]="!menuOptions[userGroupMenuOptions[userGroupMenuOptions.EditUserGroup]]">
        {{'USER_GROUPS_DETAIL.DISPLAY_NAME' | translate}}
      </bzg-input>
      <bzg-textarea class="bmc-user-group-detail__basic-data-item" [disabled]="!menuOptions[userGroupMenuOptions[userGroupMenuOptions.EditUserGroup]]" [ngModel]="currentUserGroup.description" (ngModelChange)="updateCurrentUserGroup('description', $event)" >{{'USER_GROUPS_DETAIL.DESCRIPTION' | translate}}
      </bzg-textarea>
    </div>
    <!--
    <div class="bmc-user-group-detail__section bz-space--stack-m">
      <h4>{{'USER_GROUPS_DETAIL.ADD_USER_SECTION' | translate}}</h4>
      <bzg-button-primary [icon]="'icon-list'" [size]="'s'" (click)="openUsersList()">
        {{'USER_GROUPS_DETAIL.SHOW_USER_LIST' | translate}}</bzg-button-primary>
    </div> 
    -->
    <bzg-tab-set (onSelectTab)="selectedTab = $event.index">
      <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 0}" displayName="{{'USER_GROUPS.BY_CONDITIONS' | translate | uppercase}}">
        <user-groups-conditions class="bmc-user-group-detail__tab-content" [menuOptions]="menuOptions"></user-groups-conditions>
      </bzg-tab-item>
      <bzg-tab-item [ngClass]="{'active-tab': selectedTab === 1}" displayName="{{'USER_GROUPS.BY_SPECIFIC_USER' | translate | uppercase}}">
        <user-groups-specific-user class="bmc-user-group-detail__tab-content"></user-groups-specific-user>
      </bzg-tab-item>
    </bzg-tab-set>
  </div>
  <div class="bmc-user-group-detail__buttons">
    <bzg-button-secondary class="bz-space--inline-m" (click)="cancel()">{{'GLOBAL.CANCEL' | translate}}</bzg-button-secondary>
    <bzg-button-primary (click)="save()">
      <ng-container *ngIf="(viewStatus$ | async) === 2">
        {{'GLOBAL.SAVE' | translate}}
      </ng-container>
      <ng-container *ngIf="(viewStatus$ | async) === 1">
        {{'GLOBAL.UPDATE' | translate}}
      </ng-container>
    </bzg-button-primary>
  </div>
</div>

<bzg-loading [size]="'m'" class="bz-user-groups-loading" *ngIf="isLoading">
    {{ 'GLOBAL.LOADING_DATA' | translate }}</bzg-loading>

<div class="bmc-user-group-detail__empty" *ngIf="((viewStatus$ | async) === 0) && !isLoading">
  <h3>{{'USER_GROUPS_DETAIL.EMPTY_MSG1' | translate}}</h3>
  <h4>{{'USER_GROUPS_DETAIL.EMPTY_MSG2' | translate}}</h4>
</div>
